"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminUpgradeabilityProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "address",
                name: "__admin",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x6080604052604051620010e6380380620010e683398181016040528101906200002991906200047e565b828160017f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbd60001c6200005d919062000532565b60001b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc60001b146200009557620000946200056d565b5b620000a682620001b360201b60201c565b6000815111156200012d5760008273ffffffffffffffffffffffffffffffffffffffff1682604051620000da9190620005e9565b600060405180830381855af49150503d806000811462000117576040519150601f19603f3d011682016040523d82523d6000602084013e6200011c565b606091505b50509050806200012b57600080fd5b505b505060017fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610460001c62000161919062000532565b60001b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b146200019957620001986200056d565b5b620001aa826200023a60201b60201c565b505050620006ab565b620001c9816200026960201b620004181760201c565b6200020b576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401620002029062000689565b60405180910390fd5b60007f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc60001b90508181555050565b60007fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b90508181555050565b600080823b905060008111915050919050565b6000604051905090565b600080fd5b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000620002bd8262000290565b9050919050565b620002cf81620002b0565b8114620002db57600080fd5b50565b600081519050620002ef81620002c4565b92915050565b600080fd5b600080fd5b6000601f19601f8301169050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6200034a82620002ff565b810181811067ffffffffffffffff821117156200036c576200036b62000310565b5b80604052505050565b6000620003816200027c565b90506200038f82826200033f565b919050565b600067ffffffffffffffff821115620003b257620003b162000310565b5b620003bd82620002ff565b9050602081019050919050565b60005b83811015620003ea578082015181840152602081019050620003cd565b83811115620003fa576000848401525b50505050565b600062000417620004118462000394565b62000375565b905082815260208101848484011115620004365762000435620002fa565b5b62000443848285620003ca565b509392505050565b600082601f830112620004635762000462620002f5565b5b81516200047584826020860162000400565b91505092915050565b6000806000606084860312156200049a576200049962000286565b5b6000620004aa86828701620002de565b9350506020620004bd86828701620002de565b925050604084015167ffffffffffffffff811115620004e157620004e06200028b565b5b620004ef868287016200044b565b9150509250925092565b6000819050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b60006200053f82620004f9565b91506200054c83620004f9565b92508282101562000562576200056162000503565b5b828203905092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052600160045260246000fd5b600081519050919050565b600081905092915050565b6000620005bf826200059c565b620005cb8185620005a7565b9350620005dd818560208601620003ca565b80840191505092915050565b6000620005f78284620005b2565b915081905092915050565b600082825260208201905092915050565b7f43616e6e6f742073657420612070726f787920696d706c656d656e746174696f60008201527f6e20746f2061206e6f6e2d636f6e747261637420616464726573730000000000602082015250565b600062000671603b8362000602565b91506200067e8262000613565b604082019050919050565b60006020820190508181036000830152620006a48162000662565b9050919050565b610a2b80620006bb6000396000f3fe60806040526004361061004e5760003560e01c80633659cfe6146100675780634f1ef286146100905780635c60da1b146100ac5780638f283970146100d7578063f851a440146101005761005d565b3661005d5761005b61012b565b005b61006561012b565b005b34801561007357600080fd5b5061008e60048036038101906100899190610691565b610145565b005b6100aa60048036038101906100a59190610723565b610199565b005b3480156100b857600080fd5b506100c1610267565b6040516100ce9190610792565b60405180910390f35b3480156100e357600080fd5b506100fe60048036038101906100f99190610691565b6102be565b005b34801561010c57600080fd5b506101156103c1565b6040516101229190610792565b60405180910390f35b61013361042b565b61014361013e6104aa565b6104db565b565b61014d610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff160361018d5761018881610532565b610196565b61019561012b565b5b50565b6101a1610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1603610259576101dc83610532565b60008373ffffffffffffffffffffffffffffffffffffffff1683836040516102059291906107ec565b600060405180830381855af49150503d8060008114610240576040519150601f19603f3d011682016040523d82523d6000602084013e610245565b606091505b505090508061025357600080fd5b50610262565b61026161012b565b5b505050565b6000610271610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16036102b2576102ab6104aa565b90506102bb565b6102ba61012b565b5b90565b6102c6610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16036103b557600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610367576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161035e90610888565b60405180910390fd5b7f7e644d79422f17c01e4894b5f4f588d331ebfa28653d42ae832dc59e38c9798f610390610501565b8260405161039f9291906108a8565b60405180910390a16103b081610581565b6103be565b6103bd61012b565b5b50565b60006103cb610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff160361040c57610405610501565b9050610415565b61041461012b565b5b90565b600080823b905060008111915050919050565b610433610501565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16036104a0576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161049790610943565b60405180910390fd5b6104a86105b0565b565b6000807f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc60001b9050805491505090565b3660008037600080366000845af43d6000803e80600081146104fc573d6000f35b3d6000fd5b6000807fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b9050805491505090565b61053b816105b2565b8073ffffffffffffffffffffffffffffffffffffffff167fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b60405160405180910390a250565b60007fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b90508181555050565b565b6105bb81610418565b6105fa576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016105f1906109d5565b60405180910390fd5b60007f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc60001b90508181555050565b600080fd5b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600061065e82610633565b9050919050565b61066e81610653565b811461067957600080fd5b50565b60008135905061068b81610665565b92915050565b6000602082840312156106a7576106a6610629565b5b60006106b58482850161067c565b91505092915050565b600080fd5b600080fd5b600080fd5b60008083601f8401126106e3576106e26106be565b5b8235905067ffffffffffffffff811115610700576106ff6106c3565b5b60208301915083600182028301111561071c5761071b6106c8565b5b9250929050565b60008060006040848603121561073c5761073b610629565b5b600061074a8682870161067c565b935050602084013567ffffffffffffffff81111561076b5761076a61062e565b5b610777868287016106cd565b92509250509250925092565b61078c81610653565b82525050565b60006020820190506107a76000830184610783565b92915050565b600081905092915050565b82818337600083830152505050565b60006107d383856107ad565b93506107e08385846107b8565b82840190509392505050565b60006107f98284866107c7565b91508190509392505050565b600082825260208201905092915050565b7f43616e6e6f74206368616e6765207468652061646d696e206f6620612070726f60008201527f787920746f20746865207a65726f206164647265737300000000000000000000602082015250565b6000610872603683610805565b915061087d82610816565b604082019050919050565b600060208201905081810360008301526108a181610865565b9050919050565b60006040820190506108bd6000830185610783565b6108ca6020830184610783565b9392505050565b7f43616e6e6f742063616c6c2066616c6c6261636b2066756e6374696f6e20667260008201527f6f6d207468652070726f78792061646d696e0000000000000000000000000000602082015250565b600061092d603283610805565b9150610938826108d1565b604082019050919050565b6000602082019050818103600083015261095c81610920565b9050919050565b7f43616e6e6f742073657420612070726f787920696d706c656d656e746174696f60008201527f6e20746f2061206e6f6e2d636f6e747261637420616464726573730000000000602082015250565b60006109bf603b83610805565b91506109ca82610963565b604082019050919050565b600060208201905081810360008301526109ee816109b2565b905091905056fea264697066735822122045210f3d8511bd71b6e3acf70d025f607ff5ba25bd5dc88401dc299cd9d466d764736f6c634300080f0033";
const isSuperArgs = (xs) => xs.length > 1;
class AdminUpgradeabilityProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "AdminUpgradeabilityProxy";
    }
    deploy(_logic, __admin, _data, overrides) {
        return super.deploy(_logic, __admin, _data, overrides || {});
    }
    getDeployTransaction(_logic, __admin, _data, overrides) {
        return super.getDeployTransaction(_logic, __admin, _data, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AdminUpgradeabilityProxy__factory = AdminUpgradeabilityProxy__factory;
AdminUpgradeabilityProxy__factory.bytecode = _bytecode;
AdminUpgradeabilityProxy__factory.abi = _abi;
